import React from "react";
import { Dialog } from "@/components/journey/JourneyDialog";
import { Drawer } from "@/components/journey/JourneyDrawer";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useUnitJourneyContext } from "@/hooks/useUnitJourneyContext";
import { JourneyFooter } from "@/components/journey/layout/JourneyFooter";
import { JourneyHeader } from "./layout/JourneyHeader";
import { AppLocation } from "@/lib/utils";

interface UnitJourneyWrapperProps {
    children: React.ReactNode;
}

export const UnitJourneyWrapper = ({ children }: UnitJourneyWrapperProps) => {
    const { rentalApp } = useDisplayOptionContext();
    const { isOpen, setIsOpen } = useUnitJourneyContext();

    switch (rentalApp?.location) {
        case AppLocation.DRAWER:
            return (
                <Drawer isOpen={isOpen} setIsOpen={setIsOpen}>
                    <JourneyHeader />
                    {children}
                    <JourneyFooter />
                </Drawer>
            );
        default:
            return (
                <Dialog isOpen={isOpen} setIsOpen={setIsOpen}>
                    <JourneyHeader />
                    {children}
                </Dialog>
            );
    }
};
